import { useMemo } from 'react';
import { DataProviderRowData } from '@adv-frontend/data-provider';
import { isMobile } from '@direct-frontend/platform-code';
import { ListLayoutOptions } from '@react-stately/layout';

import { ListSize } from '../../ListBoxBase/types';

const rowHeightFromSize: {
    desktop: Record<ListSize, number>;
    mobile: Record<Extract<ListSize, 'm'>, number>;
} = {
    desktop: {
        m: 44,
        s: 36,
        xs: 32,
    },
    /**
     * Высота с учётом сепаратора: https://a.yandex-team.ru/arc_vcs/adv/frontend/packages/components/src/components/ListBoxBase/ListBoxBase@mobile.css?rev=4d49c38bd04f65c8cfeb03488487121f1982fbca#L45.
     * Размер только 'm' для мобильной версии.
     */
    mobile: {
        m: 61,
    },
};

export function useVirtualizer({ size }: { size: ListSize }) {
    return useMemo<ListLayoutOptions<DataProviderRowData>>(() => {
        const rowHeight = isMobile() ? rowHeightFromSize.mobile.m : rowHeightFromSize.desktop[size];

        return {
            estimatedRowHeight: rowHeight,
        };
    }, [size]);
}
